"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useViewModel = exports.useResetViewModel = void 0;
var useResetViewModel_1 = require("./useResetViewModel");
Object.defineProperty(exports, "useResetViewModel", { enumerable: true, get: function () { return useResetViewModel_1.useResetViewModel; } });
var useViewModel_1 = require("./useViewModel");
Object.defineProperty(exports, "useViewModel", { enumerable: true, get: function () { return useViewModel_1.useViewModel; } });
//# sourceMappingURL=index.js.map